import { render, staticRenderFns } from "./demo1.vue?vue&type=template&id=4b30a9c5"
import script from "./demo1.vue?vue&type=script&lang=js"
export * from "./demo1.vue?vue&type=script&lang=js"
import style0 from "./demo1.vue?vue&type=style&index=0&id=4b30a9c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports